/*
* product-related Vue component
* ---
* Related products retrieved via Product Recommendations Ajax API
* https://shopify.dev/docs/themes/ajax-api/reference/product-recommendations
*
* Example usage:
*
* <product-related inline-template product-id="{{ product.id }}"/>
*/

import axios from 'axios';
import Slick from 'vue-slick';
import algoliaRecommend from '@algolia/recommend';
import Cookies from 'js-cookie';

import Tabs from './tabs.vue';
import Tab from './tab.vue';
import ProductItem from './product-item.js';

import { storefrontRequestConfig } from '../utils/api';
import { productQuery, transformGraphqlProduct, transformAjaxProduct, transformAlgoliaProduct } from './../utils/data';

const COOKIE_RECENTLY_VIEWED = 'recently_viewed';

export default {
    components: {
        Slick,
        Tabs,
        Tab,
        ProductItem
    },

    props: {
        productId: {
            type: String,
            required: true
        },
        currentVariantId: {
            type: String,
            required: true
        },
        sectionType: {
            type: String,
            default: 'related'
        }
    },

    data() {
        return {
            isLoading: true,
            recommendedProducts: [],
            recentlyViewedProducts: [],
            algoliaConfig: window.algoliaShopify?.config,
            slickOptions: {
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            arrows: false
                        }
                    }
                ]
            }
        }
    },

    computed:{
        searchClient() {
            return algoliaRecommend(this.algoliaConfig?.app_id, this.algoliaConfig?.search_api_key);
        }
    },

    async created() {
        // Recommended products
        const { results } =  await this._geRecommendedProducts();
        const transformedProducts = results[0].hits.map(product => {
            return transformAlgoliaProduct(product)
        })
        this.recommendedProducts = transformedProducts.filter(product => product.available)

        // Recently viewed products
        // let recentPromise = [];
        // if (Cookies.get(COOKIE_RECENTLY_VIEWED)) {
        //     const recentlyViewed = JSON.parse(Cookies.get(COOKIE_RECENTLY_VIEWED));

        //     if (!recentlyViewed.includes(this.productId))
        //         Cookies.set(COOKIE_RECENTLY_VIEWED, [this.productId, ...recentlyViewed], { expires: 1 });

        //     recentPromise = this._getRcentlyViewedProducts(recentlyViewed.slice(0, 6));

        // } else {
        //     Cookies.set(COOKIE_RECENTLY_VIEWED, [this.productId], { expires: 1 });
        // }

        // Needs to be initialised in this order so that the tab order is correct
        // await Promise.all([recommendedPromise]).then(data => {
        //     this.recommendedProducts = data[0];
        // }).catch(error => {
        //     console.log(error);
        // });

        this.isLoading = false;
    },

    methods: {
        _geRecommendedProducts() {

            if (this.sectionType == 'related') {
                return this.searchClient.getRelatedProducts([{
                    indexName: 'shopify_products',
                    objectID: this.currentVariantId
                }])
            } else {
                return this.searchClient.getFrequentlyBoughtTogether([{
                    indexName: 'shopify_products',
                    objectID: this.currentVariantId
                }])
            }
        }
    }
}